import type { Ingredient } from "../domain/types";

const vegan = ["vegetarian", "vegan"] as const;
const vegetarian = ["vegetarian"] as const;

export const ingredients: Ingredient[] = [
  {
    id: "tomato",
    name: "Tomato",
    category: "produce",
    roles: ["bulk", "acid", "umami"],
    aliases: ["tomatoes"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Domates", aliases: ["domatesler"] } },
  },
  {
    id: "spinach",
    name: "Spinach",
    category: "produce",
    roles: ["bulk", "bitter", "fresh"],
    aliases: ["baby spinach", "greens"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Ispanak", aliases: ["yeşillik"] } },
  },
  {
    id: "broccoli",
    name: "Broccoli",
    category: "produce",
    roles: ["bulk", "bitter"],
    aliases: ["broccoli florets"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Brokoli", aliases: ["brokoli parçaları"] } },
  },
  {
    id: "carrot",
    name: "Carrot",
    category: "produce",
    roles: ["bulk", "sweet"],
    aliases: ["carrots"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Havuç", aliases: ["havuçlar"] } },
  },
  {
    id: "bell-pepper",
    name: "Bell pepper",
    category: "produce",
    roles: ["bulk", "sweet", "fresh"],
    aliases: ["pepper", "capsicum"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Dolmalık biber", aliases: ["biber", "kapya biber"] },
    },
  },
  {
    id: "mushroom",
    name: "Mushroom",
    category: "produce",
    roles: ["bulk", "umami"],
    aliases: ["mushrooms", "button mushroom"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Mantar", aliases: ["mantarlar"] } },
  },
  {
    id: "zucchini",
    name: "Zucchini",
    category: "produce",
    roles: ["bulk", "fresh"],
    aliases: ["courgette"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kabak", aliases: ["sakız kabağı"] } },
  },
  {
    id: "cucumber",
    name: "Cucumber",
    category: "produce",
    roles: ["bulk", "fresh", "crunch"],
    aliases: ["cucumbers"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Salatalık", aliases: ["salatalıklar"] } },
  },
  {
    id: "eggplant",
    name: "Eggplant",
    category: "produce",
    roles: ["bulk", "umami"],
    aliases: ["aubergine"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Patlıcan", aliases: ["aubergine"] } },
  },
  {
    id: "cauliflower",
    name: "Cauliflower",
    category: "produce",
    roles: ["bulk", "bitter"],
    aliases: ["cauliflower florets"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Karnabahar", aliases: ["karnabahar parçaları"] },
    },
  },
  {
    id: "green-beans",
    name: "Green beans",
    category: "produce",
    roles: ["bulk", "fresh", "crunch"],
    aliases: ["string beans", "green bean"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Taze fasulye", aliases: ["çalı fasulyesi"] } },
  },
  {
    id: "cabbage",
    name: "Cabbage",
    category: "produce",
    roles: ["bulk", "fresh", "crunch"],
    aliases: ["green cabbage", "shredded cabbage"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Lahana", aliases: ["yeşil lahana"] } },
  },
  {
    id: "corn",
    name: "Corn",
    category: "produce",
    roles: ["sweet", "bulk", "crunch"],
    aliases: ["sweetcorn", "corn kernels"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Mısır", aliases: ["tatlı mısır", "mısır taneleri"] },
    },
  },
  {
    id: "celery",
    name: "Celery",
    category: "produce",
    roles: ["bulk", "aroma", "crunch"],
    aliases: ["celery stalk", "celery stalks"],
    dietTags: [...vegan],
    allergens: ["celery"],
    translations: { tr: { name: "Kereviz", aliases: ["kereviz sapı"] } },
  },
  {
    id: "chickpeas",
    name: "Chickpeas",
    category: "protein",
    roles: ["protein", "starch"],
    aliases: ["chickpea", "garbanzo beans"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Nohut", aliases: ["nohutlar"] } },
  },
  {
    id: "lentils",
    name: "Lentils",
    category: "protein",
    roles: ["protein", "starch"],
    aliases: ["lentil", "green lentils"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Mercimek", aliases: ["yeşil mercimek"] } },
  },
  {
    id: "tofu",
    name: "Tofu",
    category: "protein",
    roles: ["protein"],
    aliases: ["bean curd"],
    dietTags: [...vegan],
    allergens: ["soy"],
    translations: { tr: { name: "Tofu", aliases: [] } },
  },
  {
    id: "egg",
    name: "Egg",
    category: "protein",
    roles: ["protein", "fat"],
    aliases: ["eggs"],
    dietTags: [...vegetarian],
    allergens: ["egg"],
    translations: { tr: { name: "Yumurta", aliases: ["yumurtalar"] } },
  },
  {
    id: "black-beans",
    name: "Black beans",
    category: "protein",
    roles: ["protein", "starch"],
    aliases: ["black bean"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Siyah fasulye", aliases: ["siyah fasulyeler"] },
    },
  },
  {
    id: "white-beans",
    name: "White beans",
    category: "protein",
    roles: ["protein", "starch"],
    aliases: ["cannellini beans", "navy beans", "white bean"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Beyaz fasulye", aliases: ["kuru fasulye"] } },
  },
  {
    id: "edamame",
    name: "Edamame",
    category: "protein",
    roles: ["protein", "fresh"],
    aliases: ["shelled edamame", "soy beans", "soybeans"],
    dietTags: [...vegan],
    allergens: ["soy"],
    translations: { tr: { name: "Edamame", aliases: ["soya fasulyesi"] } },
  },
  {
    id: "potato",
    name: "Potato",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["potatoes"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Patates", aliases: ["patatesler"] } },
  },
  {
    id: "sweet-potato",
    name: "Sweet potato",
    category: "base",
    roles: ["starch", "sweet", "bulk"],
    aliases: ["sweet potatoes"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Tatlı patates", aliases: ["tatlı patatesler"] },
    },
  },
  {
    id: "quinoa",
    name: "Quinoa",
    category: "base",
    roles: ["starch", "protein"],
    aliases: [],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kinoa", aliases: [] } },
  },
  {
    id: "bread",
    name: "Crusty bread",
    category: "base",
    roles: ["starch", "crunch"],
    aliases: ["bread", "sourdough"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: {
      tr: { name: "Ekmek", aliases: ["somun ekmek", "ekşi maya ekmek"] },
    },
  },
  {
    id: "rice",
    name: "Rice",
    category: "base",
    roles: ["starch"],
    aliases: ["brown rice", "white rice"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Pirinç", aliases: ["esmer pirinç"] } },
  },
  {
    id: "pasta",
    name: "Pasta",
    category: "base",
    roles: ["starch"],
    aliases: ["penne", "spaghetti"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Makarna", aliases: ["penne", "spagetti"] } },
  },
  {
    id: "noodles",
    name: "Noodles",
    category: "base",
    roles: ["starch"],
    aliases: ["wheat noodles", "ramen noodles"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Erişte", aliases: ["noodle"] } },
  },
  {
    id: "tortillas",
    name: "Tortillas",
    category: "base",
    roles: ["starch"],
    aliases: ["wraps", "flour tortillas"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: {
      tr: { name: "Tortilla", aliases: ["lavaş", "un tortillası"] },
    },
  },
  {
    id: "olive-oil",
    name: "Olive oil",
    category: "richness",
    roles: ["fat"],
    aliases: ["oil", "extra virgin olive oil"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Zeytinyağı", aliases: ["yağ", "sızma zeytinyağı"] },
    },
  },
  {
    id: "tahini",
    name: "Tahini",
    category: "richness",
    roles: ["fat", "bitter"],
    aliases: ["sesame paste"],
    dietTags: [...vegan],
    allergens: ["sesame"],
    translations: { tr: { name: "Tahin", aliases: ["susam ezmesi"] } },
  },
  {
    id: "yogurt",
    name: "Yogurt",
    category: "richness",
    roles: ["fat", "acid"],
    aliases: ["greek yogurt"],
    dietTags: [...vegetarian],
    allergens: ["milk"],
    translations: { tr: { name: "Yoğurt", aliases: ["Yunan yoğurdu"] } },
  },
  {
    id: "coconut-milk",
    name: "Coconut milk",
    category: "richness",
    roles: ["fat", "sweet"],
    aliases: ["coconut cream"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: {
        name: "Hindistan cevizi sütü",
        aliases: ["hindistan cevizi kreması"],
      },
    },
  },
  {
    id: "feta",
    name: "Feta",
    category: "richness",
    roles: ["fat", "salt", "umami"],
    aliases: ["feta cheese"],
    dietTags: [...vegetarian],
    allergens: ["milk"],
    translations: { tr: { name: "Beyaz peynir", aliases: ["feta peyniri"] } },
  },
  {
    id: "avocado",
    name: "Avocado",
    category: "richness",
    roles: ["fat", "fresh"],
    aliases: ["avocados"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Avokado", aliases: ["avokadolar"] } },
  },
  {
    id: "peanut-butter",
    name: "Peanut butter",
    category: "richness",
    roles: ["fat", "protein"],
    aliases: ["peanut spread"],
    dietTags: [...vegan],
    allergens: ["peanut"],
    translations: { tr: { name: "Fıstık ezmesi", aliases: [] } },
  },
  {
    id: "cashews",
    name: "Cashews",
    category: "richness",
    roles: ["fat", "crunch"],
    aliases: ["cashew", "cashew nuts"],
    dietTags: [...vegan],
    allergens: ["tree-nut"],
    translations: { tr: { name: "Kaju", aliases: ["kaju fıstığı"] } },
  },
  {
    id: "onion",
    name: "Onion",
    category: "flavor-builder",
    roles: ["aroma", "sweet", "umami"],
    aliases: ["yellow onion"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Soğan", aliases: ["sarı soğan"] } },
  },
  {
    id: "garlic",
    name: "Garlic",
    category: "flavor-builder",
    roles: ["aroma", "umami"],
    aliases: ["garlic clove", "garlic cloves"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Sarımsak", aliases: ["sarımsak dişi", "sarımsak dişleri"] },
    },
  },
  {
    id: "ginger",
    name: "Ginger",
    category: "flavor-builder",
    roles: ["aroma", "heat", "fresh"],
    aliases: ["fresh ginger"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Zencefil", aliases: ["taze zencefil"] } },
  },
  {
    id: "cumin",
    name: "Cumin",
    category: "flavor-builder",
    roles: ["aroma"],
    aliases: ["ground cumin"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kimyon", aliases: ["toz kimyon"] } },
  },
  {
    id: "smoked-paprika",
    name: "Smoked paprika",
    category: "flavor-builder",
    roles: ["aroma", "sweet"],
    aliases: ["paprika"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Tütsülenmiş paprika", aliases: ["paprika"] },
    },
  },
  {
    id: "miso",
    name: "Miso",
    category: "flavor-builder",
    roles: ["umami", "salt"],
    aliases: ["miso paste"],
    dietTags: [...vegan],
    allergens: ["soy"],
    translations: { tr: { name: "Miso", aliases: ["miso ezmesi"] } },
  },
  {
    id: "soy-sauce",
    name: "Soy sauce",
    category: "flavor-builder",
    roles: ["umami", "salt"],
    aliases: ["shoyu"],
    dietTags: [...vegan],
    allergens: ["soy", "gluten"],
    translations: { tr: { name: "Soya sosu", aliases: [] } },
  },
  {
    id: "scallion",
    name: "Scallion",
    category: "flavor-builder",
    roles: ["aroma", "fresh", "crunch"],
    aliases: ["green onion", "spring onion", "scallions"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Taze soğan", aliases: ["yeşil soğan"] } },
  },
  {
    id: "lemon",
    name: "Lemon",
    category: "finisher",
    roles: ["acid", "fresh"],
    aliases: ["lemon juice"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Limon", aliases: ["limon suyu"] } },
  },
  {
    id: "lime",
    name: "Lime",
    category: "finisher",
    roles: ["acid", "fresh"],
    aliases: ["lime juice", "limes"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Misket limonu", aliases: ["misket limonu suyu"] },
    },
  },
  {
    id: "balsamic-vinegar",
    name: "Balsamic vinegar",
    category: "finisher",
    roles: ["acid", "sweet"],
    aliases: ["balsamic"],
    dietTags: [...vegan],
    allergens: ["sulfite"],
    translations: { tr: { name: "Balzamik sirke", aliases: ["balzamik"] } },
  },
  {
    id: "parsley",
    name: "Parsley",
    category: "finisher",
    roles: ["fresh", "bitter"],
    aliases: ["flat leaf parsley"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Maydanoz", aliases: ["düz yaprak maydanoz"] },
    },
  },
  {
    id: "cilantro",
    name: "Cilantro",
    category: "finisher",
    roles: ["fresh", "aroma"],
    aliases: ["coriander"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kişniş", aliases: ["koriander"] } },
  },
  {
    id: "basil",
    name: "Basil",
    category: "finisher",
    roles: ["fresh", "aroma"],
    aliases: ["fresh basil", "basil leaves"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Fesleğen", aliases: ["taze fesleğen"] } },
  },
  {
    id: "mint",
    name: "Mint",
    category: "finisher",
    roles: ["fresh"],
    aliases: ["mint leaves", "fresh mint"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Nane", aliases: ["nane yaprakları"] } },
  },
  {
    id: "chili-flakes",
    name: "Chili flakes",
    category: "finisher",
    roles: ["heat"],
    aliases: ["red pepper flakes", "chilli flakes"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Pul biber", aliases: ["acı pul biber"] } },
  },
  {
    id: "pumpkin-seeds",
    name: "Pumpkin seeds",
    category: "finisher",
    roles: ["crunch", "fat"],
    aliases: ["pepitas"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kabak çekirdeği", aliases: [] } },
  },
  {
    id: "walnuts",
    name: "Walnuts",
    category: "finisher",
    roles: ["crunch", "fat"],
    aliases: ["walnut", "chopped walnuts"],
    dietTags: [...vegan],
    allergens: ["tree-nut"],
    translations: { tr: { name: "Ceviz", aliases: ["ceviz içi"] } },
  },
  {
    id: "sesame-seeds",
    name: "Sesame seeds",
    category: "finisher",
    roles: ["crunch"],
    aliases: ["sesame"],
    dietTags: [...vegan],
    allergens: ["sesame"],
    translations: { tr: { name: "Susam", aliases: [] } },
  },
  {
    id: "maple-syrup",
    name: "Maple syrup",
    category: "finisher",
    roles: ["sweet"],
    aliases: ["maple"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Akçaağaç şurubu", aliases: ["bal özü"] } },
  },
  {
    id: "water",
    name: "Water",
    category: "richness",
    roles: [],
    aliases: [],
    dietTags: [...vegan],
    allergens: [],
    assumedStaple: true,
    translations: { tr: { name: "Su", aliases: [] } },
  },
  {
    id: "salt",
    name: "Salt",
    category: "flavor-builder",
    roles: ["salt"],
    aliases: [],
    dietTags: [...vegan],
    allergens: [],
    assumedStaple: true,
    translations: { tr: { name: "Tuz", aliases: [] } },
  },
  {
    id: "black-pepper",
    name: "Black pepper",
    category: "flavor-builder",
    roles: ["heat", "aroma"],
    aliases: ["pepper"],
    dietTags: [...vegan],
    allergens: [],
    assumedStaple: true,
    translations: { tr: { name: "Karabiber", aliases: ["biber"] } },
  },
  {
    id: "spaghetti",
    name: "Spaghetti",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["spaghetti pasta"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Spagetti", aliases: ["spagetti makarna"] } },
  },
  {
    id: "bok-choy",
    name: "Bok choy",
    category: "produce",
    roles: ["bulk", "bitter", "fresh"],
    aliases: ["pak choi", "bok choi", "chinese cabbage"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Bok çoy", aliases: ["pak çoy", "çin lahanası"] },
    },
  },
  {
    id: "lemongrass",
    name: "Lemongrass",
    category: "flavor-builder",
    roles: ["aroma", "fresh"],
    aliases: ["lemon grass"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Limon otu", aliases: ["limon otu sapı"] } },
  },
  {
    id: "tempeh",
    name: "Tempeh",
    category: "protein",
    roles: ["protein", "umami"],
    aliases: ["fermented tempeh"],
    dietTags: [...vegan],
    allergens: ["soy"],
    translations: { tr: { name: "Tempeh", aliases: ["fermente tempeh"] } },
  },
  {
    id: "farro",
    name: "Farro",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["emmer wheat", "farro grain"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Siyez buğdayı", aliases: ["kavılca"] } },
  },
  {
    id: "barley",
    name: "Barley",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["pearl barley"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Arpa", aliases: ["inci arpa"] } },
  },
  {
    id: "bulgur",
    name: "Bulgur",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["bulgur wheat", "cracked wheat"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Bulgur", aliases: ["bulgur buğdayı"] } },
  },
  {
    id: "couscous",
    name: "Couscous",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["couscous grains"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Kuskus", aliases: ["kuskus taneleri"] } },
  },
  {
    id: "snap-peas",
    name: "Snap peas",
    category: "produce",
    roles: ["bulk", "fresh", "sweet", "crunch"],
    aliases: ["sugar snap peas", "mangetout"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Şeker bezelyesi", aliases: ["taze bezelye"] },
    },
  },
  {
    id: "snow-peas",
    name: "Snow peas",
    category: "produce",
    roles: ["bulk", "fresh", "sweet"],
    aliases: ["mangetout", "sugar peas"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kar bezelyesi", aliases: ["mangetout"] } },
  },
  {
    id: "leek",
    name: "Leek",
    category: "produce",
    roles: ["bulk", "aroma", "sweet"],
    aliases: ["leeks"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Pırasa", aliases: ["pırasalar"] } },
  },
  {
    id: "fennel",
    name: "Fennel",
    category: "produce",
    roles: ["bulk", "aroma", "fresh", "sweet"],
    aliases: ["fennel bulb"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Rezene", aliases: ["rezene soğanı"] } },
  },
  {
    id: "chickpea-flour",
    name: "Chickpea flour",
    category: "base",
    roles: ["starch", "protein"],
    aliases: ["gram flour", "besan"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Nohut unu", aliases: ["gram unu"] } },
  },
  {
    id: "falafel",
    name: "Falafel",
    category: "protein",
    roles: ["protein", "crunch"],
    aliases: ["falafel balls", "falafel patties"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Falafel", aliases: ["falafel topları"] } },
  },
  {
    id: "rice-vinegar",
    name: "Rice vinegar",
    category: "finisher",
    roles: ["acid"],
    aliases: ["rice wine vinegar"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Pirinç sirkesi", aliases: ["pirinç şarabı sirkesi"] },
    },
  },
  {
    id: "sesame-oil",
    name: "Sesame oil",
    category: "richness",
    roles: ["fat", "aroma"],
    aliases: ["toasted sesame oil"],
    dietTags: [...vegan],
    allergens: ["sesame"],
    translations: {
      tr: { name: "Susam yağı", aliases: ["kavrulmuş susam yağı"] },
    },
  },
  {
    id: "sriracha",
    name: "Sriracha",
    category: "flavor-builder",
    roles: ["heat", "acid", "sweet"],
    aliases: ["sriracha sauce", "hot sauce"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Sriracha", aliases: ["sriracha sosu"] } },
  },
  {
    id: "chili-garlic-sauce",
    name: "Chili garlic sauce",
    category: "flavor-builder",
    roles: ["heat", "aroma"],
    aliases: ["chilli garlic sauce", "sambal"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Acı biber sarımsaklı sos", aliases: ["sambal"] },
    },
  },
  {
    id: "sun-dried-tomato",
    name: "Sun-dried tomato",
    category: "finisher",
    roles: ["umami", "acid", "sweet"],
    aliases: ["sun dried tomatoes", "sundried tomato"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Kurutulmuş domates", aliases: ["kuru domates"] },
    },
  },
  {
    id: "sumac",
    name: "Sumac",
    category: "flavor-builder",
    roles: ["acid", "aroma"],
    aliases: ["sumak"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Sumak", aliases: ["sumak baharatı"] } },
  },
  {
    id: "pomegranate-molasses",
    name: "Pomegranate molasses",
    category: "finisher",
    roles: ["acid", "sweet", "umami"],
    aliases: ["nar ekşisi", "pomegranate syrup"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Nar ekşisi", aliases: ["nar pekmezi"] } },
  },
  {
    id: "red-pepper-paste",
    name: "Red pepper paste",
    category: "flavor-builder",
    roles: ["umami", "heat", "sweet"],
    aliases: ["biber salçası", "turkish pepper paste", "hot pepper paste"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: {
        name: "Biber salçası",
        aliases: ["acı biber salçası", "tatlı biber salçası"],
      },
    },
  },
  {
    id: "tomato-paste",
    name: "Tomato paste",
    category: "flavor-builder",
    roles: ["umami", "acid", "sweet"],
    aliases: ["domates salçası", "tomato concentrate", "tomato purée"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Domates salçası", aliases: ["salça"] } },
  },
  {
    id: "dill",
    name: "Dill",
    category: "produce",
    roles: ["aroma", "fresh"],
    aliases: ["fresh dill", "dereotu"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Dereotu", aliases: ["taze dereotu"] } },
  },
  {
    id: "dried-mint",
    name: "Dried mint",
    category: "flavor-builder",
    roles: ["aroma"],
    aliases: ["kuru nane", "peppermint"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kuru nane", aliases: ["nane"] } },
  },
  {
    id: "red-onion",
    name: "Red onion",
    category: "produce",
    roles: ["bulk", "aroma", "acid", "fresh"],
    aliases: ["kırmızı soğan", "purple onion"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Kırmızı soğan", aliases: ["mor soğan"] } },
  },
  {
    id: "olives",
    name: "Olives",
    category: "richness",
    roles: ["fat", "umami", "salt"],
    aliases: ["black olives", "green olives", "zeytin"],
    dietTags: [...vegan],
    allergens: [],
    translations: {
      tr: { name: "Zeytin", aliases: ["siyah zeytin", "yeşil zeytin"] },
    },
  },
  {
    id: "pomegranate",
    name: "Pomegranate",
    category: "produce",
    roles: ["acid", "sweet", "fresh"],
    aliases: ["pomegranate seeds", "pomegranate arils", "nar"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Nar", aliases: ["nar taneleri"] } },
  },
  {
    id: "pistachios",
    name: "Pistachios",
    category: "richness",
    roles: ["fat", "crunch", "protein"],
    aliases: ["pistachio nuts", "antep fıstığı"],
    dietTags: [...vegan],
    allergens: ["tree-nut"],
    translations: { tr: { name: "Antep fıstığı", aliases: ["fıstık"] } },
  },
  {
    id: "red-wine-vinegar",
    name: "Red wine vinegar",
    category: "finisher",
    roles: ["acid"],
    aliases: ["kırmızı şarap sirkesi"],
    dietTags: [...vegan],
    allergens: ["sulfite"],
    translations: { tr: { name: "Kırmızı şarap sirkesi", aliases: ["sirke"] } },
  },
  {
    id: "flatbread",
    name: "Flatbread",
    category: "base",
    roles: ["starch", "bulk"],
    aliases: ["pide", "lavash", "yufka", "pita"],
    dietTags: [...vegan],
    allergens: ["gluten"],
    translations: { tr: { name: "Pide", aliases: ["lavaş", "yufka"] } },
  },
  {
    id: "grape-leaves",
    name: "Grape leaves",
    category: "produce",
    roles: ["bulk"],
    aliases: ["vine leaves", "asma yaprağı", "dolma leaves"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Asma yaprağı", aliases: ["yaprak"] } },
  },
  {
    id: "allspice",
    name: "Allspice",
    category: "flavor-builder",
    roles: ["aroma"],
    aliases: ["yenibahar", "ground allspice"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Yenibahar", aliases: ["bahar"] } },
  },
  {
    id: "cinnamon",
    name: "Cinnamon",
    category: "flavor-builder",
    roles: ["aroma", "sweet"],
    aliases: ["ground cinnamon", "tarçın"],
    dietTags: [...vegan],
    allergens: [],
    translations: { tr: { name: "Tarçın", aliases: ["toz tarçın"] } },
  },
];

export const ingredientById = new Map(
  ingredients.map((ingredient) => [ingredient.id, ingredient]),
);

export const selectableIngredients = ingredients.filter(
  (ingredient) => !ingredient.assumedStaple,
);
